// Right to Work share code helpers, shared by the Laila my_checks card and
// Profile → ID & RTW.
//
// A share code is nine letters and digits. The Home Office prints it as
// W12 345 678, so people type the spaces (or dashes). The gateway strips them
// too, but anything other than nine letters and digits gets a 422.

export const SHARE_CODE_LENGTH = 9;
// 'W12 345 678': the longest string the input ever shows.
export const SHARE_CODE_FORMATTED_LENGTH = 11;

export const normaliseShareCode = (value?: string | null) =>
  (value ?? '').replace(/[\s-]/g, '').toUpperCase();

export const validShareCode = (value?: string | null) => /^[A-Z0-9]{9}$/.test(normaliseShareCode(value));

// W12 345 678: how the Home Office prints it, easier to check against the letter.
export const formatShareCode = (value?: string | null) => {
  const code = normaliseShareCode(value).slice(0, SHARE_CODE_LENGTH);
  return [code.slice(0, 3), code.slice(3, 6), code.slice(6)].filter(Boolean).join(' ');
};

export const SHARE_CODE_PROBLEM = 'Share codes are 9 letters and numbers, like W12 345 678';

// Why the Right to Work check didn't start.
export const rtwErrorMessage = (error: any) => {
  switch (error?.response?.status) {
    case 422:
      return 'That share code or date of birth wasn’t accepted. Check them against your Home Office letter.';
    case 429:
      return 'A check is already running for your share code. We’ll let you know when it’s done.';
    default:
      return 'We couldn’t start the check. Please try again in a few minutes.';
  }
};
